module.exports = __webpack_public_path__ + "static/auth-bg-big-89a7103815f8b39acf815a702845de3e.jpg";